import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d853a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex-ter-cen" }
const _hoisted_3 = ["src"]


import loadingImgBlue from '@/assets/image/icon/loading_027AFF.svg'
import loadingImgBlack from '@/assets/image/icon/loading_black.svg'
import loadingImgRed from '@/assets/image/icon/loading_red.svg'
import { defineProps, defineComponent, computed } from 'vue'
const __default__ = defineComponent({
  name: 'TableButton'
})

function setup(__props) {

const props = __props

let buttonClassText = ''
const buttonClass = computed(() => {
  buttonClassText = ''
  buttonClassText += props.title.length > 6 ? 'largeButton ' : 'midButton '
  buttonClassText += props.disabled ? 'disabledButton ' : 'primaryButton '
  buttonClassText += props.loading ? 'loadingButton ' : ''
  buttonClassText += props.warning ? 'warningButton ' : ''
  buttonClassText += props.danger ? 'dangerButton ' : ''
  buttonClassText += props.info ? 'infoButton' : ''

  return buttonClassText
})

const loadingImg = computed(() => {
  if (props.disabled) {
    return loadingImgBlack
  }
  if (props.warning) {
    // return loadingImgYellow
  }
  if (props.danger) {
    return loadingImgRed
  }
  return loadingImgBlue
})

const isdisabled = computed(() => {
  return props.disabled || props.loading
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(_unref(buttonClass)),
    disabled: props.disabled
  }, [
    _createElementVNode("span", _hoisted_2, [
      (props.loading)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(loadingImg),
            alt: "",
            class: "loadingimg"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", null, _toDisplayString(props.title), 1)
      ])
    ])
  ], 10, _hoisted_1))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: () => {
      return ''
    }
  },
  loading: {
    type: Boolean,
    default: false
  },
  danger: {
    type: Boolean,
    default: false
  },
  warning: {
    type: Boolean,
    default: false
  },
  info: {
    type: Boolean,
    default: false
  }
},
  setup})